/*
export const someMutation = (state) => {}
 */

export var SET_CURRENTNAV = function SET_CURRENTNAV(state, data) {
  state.data = data;
};
export var CLEAR_CURRENTNAV = function CLEAR_CURRENTNAV(state) {
  state.data = {};
};